/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
  GetApiV1PersonSharedAcademicEducationDropdown401,
  GetApiV1PersonSharedAcademicEducationDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedAcademicEducationDropdown.ts";

function getGetApiV1PersonSharedAcademicEducationDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/academic-education-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EAcademicEducation para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de formações acadêmicas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/academic-education-dropdown}
 */
export async function getApiV1PersonSharedAcademicEducationDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAcademicEducationDropdown401
      | GetApiV1PersonSharedAcademicEducationDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedAcademicEducationDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
